import inactiveStreakIcon from '@/assets/images/possibleStreak.svg';
import ActiveStreak from './ActiveStreak';
import styles from './Streak.module.scss';

interface StreakProps {
  activeStreak?: boolean;
}

const Streak = ({ activeStreak }: StreakProps) => {
  return (
    <div
      className={styles.streakRoot}
      role="listitem"
      aria-label={activeStreak ? 'Active streak' : 'Inactive streak'}
    >
      {activeStreak ? (
        <ActiveStreak />
      ) : (
        <img src={inactiveStreakIcon} alt="Inactive streak icon" />
      )}
    </div>
  );
};

export default Streak;
